export const addressShortener = (value, countBeginning = 6, countEnd = 4) => {
  return value.length < countBeginning + countEnd
    ? value
    : value.substring(0, countBeginning) + "..." + value.substring(value.length - countEnd);
};
